const entities = {
  '&#x27;': "'",
};

const stripHTMLTags = string => (string ? string.replace(/<[^>]+>/g, '').replace(/&.{4};/g, match => entities[match] || '') : '');

export default stripHTMLTags;
